(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["porte-configuratore"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('color-swatch-selector')) {
    customElements.define('color-swatch-selector', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const input = event.target.closest('input[type="radio"]');
          if (!input) return;
          const image = this.querySelector('.cf-colors__preview-image');
          const name = this.querySelector('[data-selected-color]');
          if (name) name.textContent = input.value;
          if (image && input.dataset.swatch) {
            image.src = input.dataset.swatch;
            image.alt = input.value;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
